import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanMatch,
  Router,
  UrlSegment,
} from '@angular/router';
import { combineLatest, Observable, skipWhile } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthorizationFacade } from '../facades/authorization.facade';
import { CustomerFacade } from '../facades/customer.facade';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanMatch {
  constructor(
    private router: Router,
    private authorizationFacade: AuthorizationFacade,
    private customerFacade: CustomerFacade
  ) {
  }

  canMatch(
    _: ActivatedRouteSnapshot,
    segments: UrlSegment[]
  ): Observable<boolean> {
    return combineLatest([
      this.authorizationFacade.isLoginInProcess$,
      this.authorizationFacade.isAuthenticated$,
      this.customerFacade.selectIsGuest(),
      this.customerFacade.selectIsCustomerLoaded()
    ]).pipe(
      skipWhile(([isLoginInProcess]) => isLoginInProcess),
      filter(([, isAuthenticated, , isCustomerLoaded]) => !isAuthenticated || (isAuthenticated && isCustomerLoaded)),
      take(1),
      map(([, isAuthenticated, isGuest]) => {
        if (isAuthenticated && !isGuest) {
          return true;
        }
        this.router.navigate([segments[0].path]).then();
        return false;
      })
    );
  }
}
